export default function(data) {
var __t, __p = '';
__p += '<h2 class="modal-title">Thanks! Now check your email.</h2>\n<div class="col large-10 medium-10 large-push-1 medium-push-1 modal-description">\n  <p>' +
((__t = ( data.message )) == null ? '' : __t) +
'</p>\n  <p><span class="link modal-link" data-modal="reset_password">Didn\'t get the email? Try Again!</span></p>\n</div>\n';
return __p
}